<template>
  <div class="pnlMenu">
    <div :class="[nowTab == 'Home' ? 'pnlMenuSelect' : 'pnlMenuUnSelect']" @click="BackHome">
      <img class="imgIcon" src="@/assets/img/menu/icon_home_Hover.png" />
      <label class="lblMenu">{{ $t('Menu.Home') }}</label>
    </div>
    <div :class="[nowTab == 'ClassSetting' ? 'pnlMenuSelect' : 'pnlMenuUnSelect']" @click="BackClassSetting">
      <img class="imgIcon" src="@/assets/img/menu/icon_class_Hover.png" />
      <label class="lblMenu">{{ $t('Menu.ClassSetting') }}</label>
    </div>
    <hr class="hrMenu" />

    <div
      :class="[nowApp == 'SurrealClassRoom' ? 'pnlMenuBoxSelect' : 'pnlMenuBoxUnSelect']"
      @click.self="BackSCR_Model"
      v-if="AppShow('Teaching Cool')"
    >
      <img class="imgIcon" src="@/assets/img/menu/icon_SE_Hover.png" @click.self="BackSCR_Model" />
      <label class="lblMenu" @click.self="BackSCR_Model">{{ $t('Menu.TeachingCool') }}</label>
      <img class="imgHint" src="@/assets/img/menu/icon_menu_arrow.png" @click.self="BackSCR_Model" />
      <br />

      <div class="pnlSubMenu">
        <div :class="[nowTab == 'Models' ? 'pnlSubMenuSelect' : 'pnlSubMenuUnSelect']" @click="BackSCR_Model">
          <img class="imgSubMenu" src="@/assets/img/menu/icon_serch_Hover.png" />
          <label class="lblSubMenu">{{ $t('Menu.ModelSearch') }}</label>
        </div>
        <div :class="[nowTab == 'Favorite' ? 'pnlSubMenuSelect' : 'pnlSubMenuUnSelect']" @click="BackSCR_Favorite">
          <img class="imgSubMenu" src="@/assets/img/menu/icon_heart_Hover.png" />
          <label class="lblSubMenu">{{ $t('Menu.FavoriteModel') }}</label>
        </div>
        <div :class="[nowTab == 'Customize' ? 'pnlSubMenuSelect' : 'pnlSubMenuUnSelect']" @click="BackSCR_Customize">
          <img class="imgSubMenu" src="@/assets/img/menu/icon_Custom_Hover.png" />
          <label class="lblSubMenu">{{ $t('Menu.CustomChapter') }}</label>
        </div>
      </div>
    </div>
    <div style="clear: both"></div>

    <div
      :class="[nowApp == 'SpellingGladiator' ? 'pnlMenuBoxSelect' : 'pnlMenuBoxUnSelect']"
      @click.self="BackSESG_Customize"
      v-if="AppShow('Spelling Gladiator')"
    >
      <img class="imgIcon" src="@/assets/img/menu/icon_SE_Hover.png" @click.self="BackSESG_Customize" />
      <label class="lblMenu" @click.self="BackSESG_Customize">{{ $t('Menu.SESG') }}</label>
      <img class="imgHint" src="@/assets/img/menu/icon_menu_arrow.png" @click.self="BackSCR_Model" />
      <br />
      <div class="pnlSubMenu">
        <div :class="[nowTab == 'SgCustomize' ? 'pnlSubMenuSelect' : 'pnlSubMenuUnSelect']" @click="BackSESG_Customize">
          <img class="imgSubMenu" src="@/assets/img/menu/icon_Custom_Hover.png" />
          <label class="lblSubMenu">{{ $t('Menu.CustomChapter') }}</label>
        </div>
        <div :class="[nowTab == 'SgRecord' ? 'pnlSubMenuSelect' : 'pnlSubMenuUnSelect']" @click="BackSESG_Record">
          <img class="imgSubMenu" src="@/assets/img/menu/icon_clock_Hover.png" />
          <label class="lblSubMenu">{{ $t('Menu.Record') }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  data() {
    return {
      nowTab: '',
      nowApp: '',
    };
  },
  mounted() {
    this.nowTab = this.GetRouteName();
    this.nowApp = this.GetRouteAppName();
  },
  computed: {},
  methods: {
    GetRouteName() {
      //return this.$router.currentRoute.name.toLowerCase();
      return this.$router.currentRoute.name;
    },
    GetRouteAppName() {
      var path = this.$route.fullPath;
      if (path.includes('SurrealClassRoom')) {
        return 'SurrealClassRoom';
      } else if (path.includes('SpellingGladiator')) {
        return 'SpellingGladiator';
      } else {
        return '';
      }
    },
    BackHome() {
      if (this.nowTab != 'Home') {
        this.$router.push({ path: '/Home' });
        this.nowTab = 'Home';
      }
    },
    BackClassSetting() {
      if (this.nowTab != 'ClassSetting') {
        this.$router.push({ path: '/Setting/ClassSetting' });
        this.nowTab = 'ClassSetting';
      }
    },
    BackSCR_Model() {
      if (this.nowTab != 'Models') {
        this.$router.push({ path: '/SurrealClassRoom/Models' });
        this.nowTab = 'Models';
      }
    },
    BackSCR_Favorite() {
      if (this.nowTab != 'Favorite') {
        this.$router.push({ path: '/SurrealClassRoom/Favorite' });
        this.nowTab = 'Favorite';
      }
    },
    BackSCR_Customize() {
      if (this.nowTab != 'Customize') {
        this.$router.push({ path: '/SurrealClassRoom/Customize' });
        this.nowTab = 'Customize';
      }
    },
    BackSESG_Customize() {
      if (this.nowTab != 'SgCustomize') {
        this.$router.push({ path: '/SpellingGladiator/Customize' });
        this.nowTab = 'SgCustomize';
      }
    },
    BackSESG_Record() {
      if (this.nowTab != 'SgRecord') {
        this.$router.push({ path: '/SpellingGladiator/Record' });
        this.nowTab = 'SgRecord';
      }
    },
  },
};
</script>